import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { iPaginationRequest, iPaginationResult } from 'src/app/helpers/Interfaces/pagination';
import { iTaskFiltrationStatus } from 'src/app/helpers/Interfaces/status';
import { iTaskReq } from 'src/app/helpers/Interfaces/task';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class StatusesService {
  private _getAllStatuses = `${environment.base_url}/api/Status/GetAll`;
  private _getAllPaginated = `${environment.base_url}/api/Status/GetAllNew`;
  private _getStatusByName = `${environment.base_url}/api/Status/GetByName`;
  private _addStatus = `${environment.base_url}/api/Status/Add`;
  private _updateStatus = `${environment.base_url}/api/Status/Update`;
  private _removeStatus = `${environment.base_url}/api/Status/Remove`;
  private _getForTaskFiltration = `${environment.base_url}/api/Status/GetNewTaskByStatus`;
  constructor(private _http: HttpClient) { }

  GetAllStatuses() {
    return this._http.get<Array<any>>(this._getAllStatuses, {
      responseType: 'json',
    });
  }
  getAllPaginated(payload: iPaginationRequest) {
    return this._http.post<iPaginationResult<any>>(
      `${this._getAllPaginated}`,
      payload,
      {
        responseType: 'json',
      }
    );
  }
  GetStatusByName(name: string) {
    return this._http.get<any>(`${this._getStatusByName}?name=${name}`, {
      responseType: 'json',
    });
  }
  AddStatus(payload: any) {
    return this._http.post<any>(this._addStatus, payload, {
      responseType: 'json',
    });
  }
  UpdateStatus(payload: any) {
    return this._http.put<any>(this._updateStatus, payload, {
      responseType: 'json',
    });
  }
  DeleteStatus(id: any) {
    return this._http.delete(`${this._removeStatus}?id=${id}`);
  }
  getForTaskFiltration(dto: iTaskReq) {
    return this._http.post<iTaskFiltrationStatus[]>(
      this._getForTaskFiltration,
      dto,
      {
        responseType: 'json',
      }
    );
  }
}
